"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4107],{

/***/ 53742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



var NoSsr = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: props.children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(NoSsr);
}, {
    ssr: false
}));


/***/ }),

/***/ 64480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ai": function() { return /* binding */ useAddOrUpdate; },
/* harmony export */   "F2": function() { return /* binding */ useDeleteMany; },
/* harmony export */   "Hk": function() { return /* binding */ useDataTableList; },
/* harmony export */   "R2": function() { return /* binding */ useDelete; },
/* harmony export */   "kY": function() { return /* binding */ useDetail; },
/* harmony export */   "sm": function() { return /* binding */ useList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50930);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22970);
/* harmony import */ var hyper_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32785);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87148);
/* harmony import */ var services_AuthServices__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(960);
/* harmony import */ var services_BackendSDKService__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40424);











function useList(collectionKey, options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        collectionKey
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        services_BackendSDKService__WEBPACK_IMPORTED_MODULE_4__/* .bSdk.cmsQuery */ .P.cmsQuery(collectionKey, undefined, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                            authToken: services_AuthServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getToken */ .Z.getToken()
                        }, options))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result === null || result === void 0 ? void 0 : result.data
                    ];
            }
        });
    }));
}
function useDataTableList(collectionKey) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var setState = function setState(obj) {
        _setState((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state, obj));
    };
    var setPage = function setPage(page) {
        setState({
            page: page
        });
    };
    var getDataTableProps = function getDataTableProps() {
        return {
            data: query.data || [],
            page: state.page - 1,
            onChangePage: function(page, pageSize) {
                setState({
                    pageSize: pageSize,
                    page: page + 1
                });
            },
            isLoading: query.isFetching,
            error: query.error,
            totalCount: count.current,
            options: {
                pageSize: state.pageSize
            },
            onReload: function() {
                query.refetch();
            },
            tableRef: tableRef
        };
    };
    var getDataListProps = function getDataListProps() {
        var hasNextPage = !!(state.pageSize && count.current && state.page < (count.current || 0) / state.pageSize);
        return {
            data: query.data || [],
            page: state.page - 1,
            onPageChange: function(page, pageSize) {
                setState({
                    pageSize: pageSize,
                    page: page + 1
                });
            },
            isLoading: query.isFetching,
            error: query.error,
            totalCount: count.current,
            pageSize: state.pageSize,
            hasNextPage: hasNextPage
        };
    };
    var reloadData = function reloadData() {
        query.remove();
        query.refetch();
    };
    var ref, ref1, ref2, ref3;
    var key = options.key, otherOptions = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(options, [
        "key"
    ]);
    var count = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var tableRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var ref4, ref5;
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        page: (ref4 = (ref = otherOptions.query) === null || ref === void 0 ? void 0 : ref.page) !== null && ref4 !== void 0 ? ref4 : 1,
        pageSize: (ref5 = (ref1 = otherOptions.query) === null || ref1 === void 0 ? void 0 : ref1.pageSize) !== null && ref5 !== void 0 ? ref5 : 10,
        sort: ((ref2 = otherOptions.query) === null || ref2 === void 0 ? void 0 : ref2.sort) || "CreatedAt",
        sortOrder: ((ref3 = otherOptions.query) === null || ref3 === void 0 ? void 0 : ref3.sortOrder) || "desc"
    }), state = ref6[0], _setState = ref6[1];
    var query = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        collectionKey
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(key || []), [
        state
    ]), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(ec) {
            var result, ref;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(typeof options.fetchCB === "function")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            options.fetchCB((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                                includeCount: true
                            }))
                        ];
                    case 1:
                        result = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            services_BackendSDKService__WEBPACK_IMPORTED_MODULE_4__/* .bSdk.cmsQuery */ .P.cmsQuery(collectionKey, undefined, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                authToken: services_AuthServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getToken */ .Z.getToken()
                            }, otherOptions), {
                                query: {
                                    page: state.page,
                                    pageSize: state.pageSize,
                                    includeCount: true,
                                    sort: state.sort,
                                    sortOrder: state.sortOrder
                                }
                            }))
                        ];
                    case 3:
                        result = _state.sent();
                        _state.label = 4;
                    case 4:
                        count.current = result === null || result === void 0 ? void 0 : result.TotalRowCount;
                        if (options.isInfinitePagination && query.data) {
                            ;
                            result.data = (ref = query.data) === null || ref === void 0 ? void 0 : ref.concat(result.data);
                        }
                        return [
                            2,
                            result === null || result === void 0 ? void 0 : result.data
                        ];
                }
            });
        });
        return function(ec) {
            return _ref.apply(this, arguments);
        };
    }(), {
        keepPreviousData: options.isInfinitePagination,
        cacheTime: options.noCache ? 0 : undefined,
        retry: options.noCache ? false : undefined
    });
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, query, state), {
        setPage: setPage,
        setState: setState,
        totalCount: count.current || 0,
        get dataTableProps () {
            return getDataTableProps();
        },
        get dataListProps () {
            return getDataListProps();
        },
        reloadData: reloadData
    });
}
function useDetail(collectionKey, id, queryOptions) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        collectionKey,
        id
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!id) throw new Error("Provide id to get for ".concat(collectionKey, "."));
                    return [
                        4,
                        services_BackendSDKService__WEBPACK_IMPORTED_MODULE_4__/* .bSdk.cmsQuery */ .P.cmsQuery(collectionKey, undefined, {
                            route: "/".concat(id),
                            authToken: services_AuthServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getToken */ .Z.getToken()
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result === null || result === void 0 ? void 0 : result.data
                    ];
            }
        });
    }), queryOptions);
}
function useAddOrUpdate(collectionKey, options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useMutation)([
        collectionKey
    ], function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(data) {
            var isUpdate, result;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(options === null || options === void 0 ? void 0 : options.before)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            options === null || options === void 0 ? void 0 : options.before(data)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        isUpdate = !!data._id;
                        return [
                            4,
                            services_BackendSDKService__WEBPACK_IMPORTED_MODULE_4__/* .bSdk.cmsQuery */ .P.cmsQuery(collectionKey, data, {
                                route: isUpdate ? "/".concat(data._id) : "/",
                                method: isUpdate ? "PUT" : "POST",
                                authToken: services_AuthServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getToken */ .Z.getToken()
                            })
                        ];
                    case 3:
                        result = _state.sent();
                        if (!(options === null || options === void 0 ? void 0 : options.after)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            options === null || options === void 0 ? void 0 : options.after(result === null || result === void 0 ? void 0 : result.data)
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            2,
                            result === null || result === void 0 ? void 0 : result.data
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }());
}
function useDelete(collectionKey) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useMutation)([
        collectionKey
    ], function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(id) {
            var confirm, result;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!id) throw new Error("Provide id to delete.");
                        return [
                            4,
                            hyper_utils__WEBPACK_IMPORTED_MODULE_0__.AlertUtils.showConfirm(options.confirmMessage || "Do you want to delete this?")
                        ];
                    case 1:
                        confirm = _state.sent();
                        if (!confirm) return [
                            2,
                            null
                        ];
                        return [
                            4,
                            services_BackendSDKService__WEBPACK_IMPORTED_MODULE_4__/* .bSdk.cmsQuery */ .P.cmsQuery(collectionKey, undefined, {
                                route: "/".concat(id),
                                method: "DELETE",
                                authToken: services_AuthServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getToken */ .Z.getToken()
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result === null || result === void 0 ? void 0 : result.data
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }());
}
function useDeleteMany(collectionKey) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useMutation)([
        collectionKey
    ], function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(ids) {
            var confirm, result;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!Array.isArray(ids)) throw new Error("Provide ids to delete.");
                        return [
                            4,
                            hyper_utils__WEBPACK_IMPORTED_MODULE_0__.AlertUtils.showConfirm("Do you want to delete this?")
                        ];
                    case 1:
                        confirm = _state.sent();
                        if (!confirm) return [
                            2,
                            null
                        ];
                        return [
                            4,
                            services_BackendSDKService__WEBPACK_IMPORTED_MODULE_4__/* .bSdk.cmsQuery */ .P.cmsQuery(collectionKey, {
                                _ids: ids
                            }, {
                                route: "/batch",
                                method: "DELETE",
                                authToken: services_AuthServices__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getToken */ .Z.getToken()
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result === null || result === void 0 ? void 0 : result.data
                        ];
                }
            });
        });
        return function(ids) {
            return _ref.apply(this, arguments);
        };
    }());
}


/***/ }),

/***/ 39461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useModal; },
/* harmony export */   "v": function() { return /* binding */ useModalContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64666);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37645);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23972);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54799);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35713);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92679);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75672);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77256);
/* harmony import */ var _userIsMobile__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2954);








var useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return (0,_mui_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        dialogTitle: {
            color: theme.palette.primary.main,
            fontWeight: "bold",
            padding: "8px 8px"
        },
        closeButton: {
            padding: "4px"
        }
    });
});
var Cntxt = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    open: false,
    toggle: function() {
        return undefined;
    },
    onComplete: function() {
        return undefined;
    }
});
var useModalContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Cntxt);
};
/**
 * @function useModal 
 * @deprecated <div style="background-color: #FF0000; color: #FFFF00; padding: 5px; border-radius: 5px; font-weight: bold;"> Deprecated. 
 replaced by `showDialog` and `showConfirmDialog`</div>
 * @category Frontend
 * @subcategory Use Modal
 * @param {ReactNode | Function} children - Modal Body. This will be body component. If you want to pass It can be string, jsx or callback that receive IModalComponentProps. 
 * - if you want use IModalComponentProps inside Body component of modal you use pass callback here. 
 ```
// Pass all IModalComponentProps to Modal Body Component
const modal = useModal(
  (props) => <AddUpdateBookmark {...props} bookmarkIndex={bookmarkIndex} />,
  {
    noTitle: true, // This will not render title and title needs to be rendered inside body using <ModalTitle />
    onComplete: () => { 
      modal.toggle(false);
      list.refetch();
    },
    maxWidth: "md",
  }
);
  ```
 * @param {Object} props
 * @param {string} props.title - Title that need to be shown on modal. 
 * - Well, This method is useful for simple case. But, This title do not have access to the `state` of body component. That's why we use `noTitle` many times and 
 * render <ModalTitle /> inside the modal body
 * @param {boolean} props.noTitle - Do not show title. 
 * @param {xs|sm|md|lg|xl} props.maxWidth - Dialog width similar to mui maxWidth
 * @param {object} props.dialogProps - Extra dialog props needs to be supplied to <Dialog />  component
 * @param {boolean} props.stopRenderingWithoutContext - Do not render body component if there is no context provided. 
 * @param {Function} props.onComplete - Callback function that will be called from inside Modal Body. This suggest that work of modal is complete. 
 *  Parent can close modal or call show success on this callback. 
 * @param TContextObject This is template param passed for typescript. You can pass which typeof context object you want to use. 
 * @example
// Init Hook
const modal = useModal(
  (props) => <BodyComponent {...props}/>,
  {
    title: "Some title",
    onComplete: () => {
      modal.toggle(false); // Close on complete
      list.refetch(); // Refresh data table
    },
    maxWidth: "md",
  }
);

// Make sure to do this inside jsx of current component otherwise Modal will not show. 
{modal.render()}

// Open modal by calling
modal.toggle(true);

// you can pass context object to toggle
modal.toggle(true, {id: "some id"});

// Close modal by calling 
modal.toggle(false);
 */ function useModal(children) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var renderChildren = function renderChildren() {
        if (typeof children === "function") {
            if (props.stopRenderingWithoutContext && !currentData) return null;
            return children({
                onComplete: onComplete,
                toggle: toggle,
                contextObject: currentData,
                key: currentData ? JSON.stringify(currentData) : undefined
            });
        }
        return children;
    };
    var render = function render() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Cntxt.Provider, {
            value: {
                open: open,
                toggle: toggle,
                onComplete: onComplete,
                data: currentData
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                open: open,
                onClose: function() {
                    return toggle(false);
                },
                maxWidth: props.maxWidth || "sm",
                fullWidth: true,
                fullScreen: isMobile
            }, props.dialogProps), {
                children: open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        !props.noTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        color: "inherit",
                                        width: "100%",
                                        children: props.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        style: {
                                            flexGrow: 1
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        style: {
                                            backgroundColor: "white"
                                        },
                                        onClick: toggle,
                                        className: classes.closeButton,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            color: "primary"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            style: {
                                paddingTop: 8
                            },
                            children: renderChildren()
                        })
                    ]
                })
            }))
        });
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), currentData = ref1[0], setCurrentData = ref1[1];
    var classes = useStyles({});
    var isMobile = (0,_userIsMobile__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)();
    var toggle = function(o, data) {
        setOpen(typeof o === "boolean" ? o : !open);
        setCurrentData(data);
    };
    var onComplete = function(o) {
        if (props.onComplete) props.onComplete(o);
    };
    return {
        toggle: toggle,
        open: open,
        render: render
    };
}


/***/ }),

/***/ 2954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIsMobile; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98396);

function useIsMobile() {
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var isMobile = (0,_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(theme.breakpoints.down("md"));
    return isMobile;
}


/***/ }),

/***/ 34107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MainLayout; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./hooks/commonQuries.ts
var commonQuries = __webpack_require__(64480);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./common/app/AppTitle.tsx





function flattenNav(array) {
    var result = [];
    array.forEach(function(a) {
        result.push(a);
        if (Array.isArray(a.Children)) {
            result = result.concat(flattenNav(a.Children));
        }
    });
    return result;
}
function AppTitle() {
    var navList = (0,commonQuries/* useList */.sm)("nav-list");
    var router = (0,next_router.useRouter)();
    var title = "Advance Automation";
    var flatNav = (0,react.useMemo)(function() {
        return flattenNav(navList.data || []);
    }, [
        navList.data
    ]);
    if (navList.data && flatNav) {
        var obj = flatNav.find(function(item) {
            var ref;
            return item === null || item === void 0 ? void 0 : (ref = item.Path) === null || ref === void 0 ? void 0 : ref.startsWith(router.pathname);
        });
        if (obj === null || obj === void 0 ? void 0 : obj.Title) title = "".concat(obj === null || obj === void 0 ? void 0 : obj.Title, " - ").concat(title);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
            children: title
        })
    });
}

// EXTERNAL MODULE: ./common/NoSSR.tsx
var NoSSR = __webpack_require__(53742);
// EXTERNAL MODULE: ./hooks/userIsMobile.ts
var userIsMobile = __webpack_require__(2954);
// EXTERNAL MODULE: ../../node_modules/hyper-utils/dist/module.js
var dist_module = __webpack_require__(32785);
// EXTERNAL MODULE: ./layouts/common/NavigationListener.tsx
var NavigationListener = __webpack_require__(36663);
// EXTERNAL MODULE: ./stores/commonStore.ts
var commonStore = __webpack_require__(88658);
// EXTERNAL MODULE: ./node_modules/@mui/material/Slide/Slide.js
var Slide = __webpack_require__(54776);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(21023);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(87952);
// EXTERNAL MODULE: ./node_modules/@mui/material/Toolbar/Toolbar.js
var Toolbar = __webpack_require__(83808);
// EXTERNAL MODULE: ../../node_modules/@mui/styles/makeStyles/makeStyles.js + 4 modules
var makeStyles = __webpack_require__(75672);
// EXTERNAL MODULE: ./common/misc/RIcon.tsx
var RIcon = __webpack_require__(84144);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./node_modules/@mui/material/Autocomplete/Autocomplete.js
var Autocomplete = __webpack_require__(23776);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(22715);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js
var ListItem = __webpack_require__(29861);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemAvatar/ListItemAvatar.js
var ListItemAvatar = __webpack_require__(68476);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ../../node_modules/fuse.js/dist/fuse.mjs
var dist_fuse = __webpack_require__(89325);
// EXTERNAL MODULE: ./services/Utils.ts
var Utils = __webpack_require__(18351);
// EXTERNAL MODULE: ./utils/winUtils.ts
var winUtils = __webpack_require__(94212);
;// CONCATENATED MODULE: ./common/searchModal/GlobalSearchModal.tsx












function GlobalSearchModal(props) {
    var navControls = (0,commonQuries/* useList */.sm)("nav-list").data;
    var router = (0,next_router.useRouter)();
    var theme = (0,useTheme/* default */.Z)();
    (0,react.useEffect)(function() {
        var onKeyDownUp = function(e) {
            (0,winUtils/* setWindow */.O6)("ctrlPressed", e.ctrlKey);
        };
        document.addEventListener("keydown", onKeyDownUp);
        document.addEventListener("keyup", onKeyDownUp);
        return function() {
            document.removeEventListener("keydown", onKeyDownUp);
            document.removeEventListener("keyup", onKeyDownUp);
        };
    }, []);
    var menuAry = [];
    function menuList(navLst) {
        var parentPath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        if (!navLst) return [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = navLst[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (item.Path) {
                    var displayPath = parentPath ? "".concat(parentPath, " -> ").concat(item.Title) : item.Title;
                    menuAry.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        displayPath: displayPath
                    }));
                } else if (item.Children && item.Children.length > 0) {
                    var displayPath1 = parentPath ? "".concat(parentPath, " -> ").concat(item.Title) : item.Title;
                    menuList(item.Children, displayPath1);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    menuList(navControls);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                align: "center",
                color: theme.palette.error.main,
                variant: "caption",
                children: [
                    "Try ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "Ctrl+Windows"
                    }),
                    " or ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "Ctrl+K"
                    }),
                    " next time you wanna search",
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
                // sx={{ p: 0, m: 0, borderColor: "green" }}
                fullWidth: true,
                renderInput: function(params) {
                    return /*#__PURE__*/ (0,react.createElement)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        color: "success"
                    }, params), {
                        inputRef: function(input) {
                            if (input != null) {
                                input.focus();
                            }
                        },
                        inputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params.inputProps), {
                            autoComplete: "off",
                            sx: {
                                height: "37px"
                            }
                        }),
                        placeholder: "Search Menu",
                        autoComplete: "off",
                        key: params.id
                    }));
                },
                renderOption: function(renderProps, option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, renderProps), {
                        divider: true,
                        disableGutters: true,
                        // @ts-ignore
                        component: "a",
                        href: option.Path || "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    style: {
                                        backgroundColor: Utils/* default.stringToColor */.Z.stringToColor(option.Title),
                                        height: "45px",
                                        width: "45px"
                                    },
                                    children: option.Icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RIcon/* default */.Z, {
                                        name: option.Icon
                                    }) : Utils/* default.getFirstCharCap */.Z.getFirstCharCap(option.Title)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                primary: option.Title,
                                secondary: option.displayPath
                            })
                        ]
                    }));
                },
                options: menuAry || [],
                getOptionLabel: function(option) {
                    return option.Title;
                },
                isOptionEqualToValue: function(option, value) {
                    return true;
                },
                onChange: function(e, option) {
                    if (option === null || option === void 0 ? void 0 : option.Path) {
                        var ref;
                        if ((ref = (0,winUtils/* getWindow */.Jj)()) === null || ref === void 0 ? void 0 : ref.ctrlPressed) window.open(option.Path);
                        else router.push(option.Path);
                        props.onComplete();
                    }
                },
                filterOptions: function(optionList, state) {
                    var fuse = new dist_fuse/* default */.Z(optionList, {
                        keys: [
                            "Title",
                            "Path"
                        ]
                    });
                    return fuse.search(state.inputValue, {
                        limit: 5
                    }).map(function(i) {
                        return i.item;
                    });
                // let keyword = state.inputValue || "";
                // return optionList.filter((option) => {
                //   let aryVariations: any[] = [];
                //   if (option.Title) {
                //     let name = option.Title?.toLowerCase();
                //     aryVariations.push(name);
                //     aryVariations.push(name.replace(/ /g, "").toLowerCase());
                //     aryVariations = aryVariations.concat(name.split(" "));
                //   }
                //   if (option.Path) aryVariations.push(option.Path);
                //   return aryVariations.some(
                //     (variation) =>
                //       RegExp(keyword, "i").test(variation) ||
                //       RegExp(keyword.replace(/ /g, "").toLowerCase(), "i").test(
                //         variation
                //       )
                //   );
                // });
                },
                autoHighlight: true,
                clearOnBlur: false
            })
        ]
    });
}

// EXTERNAL MODULE: ./contexts/AuthContext.tsx
var AuthContext = __webpack_require__(51228);
// EXTERNAL MODULE: ./hooks/useModal.tsx
var useModal = __webpack_require__(39461);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./stores/authStore.ts
var authStore = __webpack_require__(86768);
;// CONCATENATED MODULE: ./layouts/main/MasterClientSelector.tsx








function MasterClientSelector() {
    var ref, ref1;
    var ref2 = authStore/* AuthStore.useState */.Cn.useState(), selectedMasterClient = ref2.selectedMasterClient, user = ref2.user;
    var isMobile = (0,userIsMobile/* default */.Z)();
    if (!(user === null || user === void 0 ? void 0 : (ref = user.Access) === null || ref === void 0 ? void 0 : ref.MasterClients)) return null;
    var MasterClients = (0,_to_consumable_array/* default */.Z)(user.Access.MasterClients).sort(function(a, b) {
        return a.CorporationName.localeCompare(b.CorporationName);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
        options: MasterClients,
        value: selectedMasterClient || null,
        style: {
            minWidth: isMobile ? 200 : 250
        },
        onChange: function(e, obj) {
            (0,authStore/* setSelectedMasterClient */.WL)(obj);
        },
        isOptionEqualToValue: function(o, v) {
            return o._id === v._id;
        },
        disabled: (user === null || user === void 0 ? void 0 : (ref1 = user.Access) === null || ref1 === void 0 ? void 0 : ref1.MasterClients.length) === 1,
        getOptionLabel: function(o) {
            return o.CorporationName;
        },
        ListboxProps: {
            style: {
                maxHeight: 650
            }
        },
        renderOption: function(props, option) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            src: option.LogoURL,
                            children: "M"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                        primary: option.CorporationName
                    })
                ]
            }));
        },
        renderInput: function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                inputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.inputProps), {
                    autoComplete: "off",
                    style: {
                        color: "blue",
                        fontWeight: "bold"
                    }
                })
            }));
        }
    });
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./node_modules/@mui/material/Badge/Badge.js + 1 modules
var Badge = __webpack_require__(22067);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popover/Popover.js
var Popover = __webpack_require__(90103);
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(47591);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(69397);
// EXTERNAL MODULE: ./hooks/useServerEvent.tsx
var useServerEvent = __webpack_require__(56043);
// EXTERNAL MODULE: ./layouts/common/colors.ts
var colors = __webpack_require__(93181);
// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(87148);
// EXTERNAL MODULE: ./services/AuthServices.ts
var AuthServices = __webpack_require__(960);
// EXTERNAL MODULE: ./services/BackendSDKService.ts
var BackendSDKService = __webpack_require__(40424);
// EXTERNAL MODULE: ./services/ReactQueryClient.ts
var ReactQueryClient = __webpack_require__(51560);
// EXTERNAL MODULE: ./utils/snackBarUtils.tsx
var snackBarUtils = __webpack_require__(31587);
;// CONCATENATED MODULE: ./layouts/main/NotificationMenu.tsx



















function NotificationMenu() {
    var user = (0,AuthContext/* useAuth */.a)().user;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,userIsMobile/* default */.Z)();
    var lstNotification = (0,commonQuries/* useList */.sm)("notification-instance", {
        query: {
            sort: "CreatedAt",
            sortOrder: "desc"
        }
    });
    var unreadNotificationCount = (0,es.useQuery)("unreadNotificationCount", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        BackendSDKService/* bSdk.cmsQuery */.P.cmsQuery("system-users", undefined, {
                            route: "/getUnreadNotificationCount",
                            method: "get",
                            authToken: AuthServices/* default.getToken */.Z.getToken()
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    }));
    var markNotificationRead = (0,es.useMutation)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            BackendSDKService/* bSdk.cmsQuery */.P.cmsQuery("notification-instance", data, {
                                route: "/markNotificationRead",
                                method: "post",
                                authToken: AuthServices/* default.getToken */.Z.getToken()
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }());
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    (0,useServerEvent/* default */.Z)([
        "notification-update-".concat(user === null || user === void 0 ? void 0 : user._id)
    ], function(message) {
        if ((message === null || message === void 0 ? void 0 : message.data) && message.data._id) {
            ReactQueryClient/* queryClient.refetchQueries */.Eh.refetchQueries([
                "notification-instance"
            ]);
            ReactQueryClient/* queryClient.refetchQueries */.Eh.refetchQueries([
                "unreadNotificationCount"
            ]);
            if (!document.hidden) {
                snackBarUtils/* default.Show */.Z.Show(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            dangerouslySetInnerHTML: {
                                __html: message.data.Title
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: message.data.Description
                            }
                        })
                    ]
                }), {
                    persist: true,
                    variant: "info"
                });
            }
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            width: 60
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                size: "large",
                edge: "end",
                onClick: handleClick,
                color: "inherit",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                    badgeContent: unreadNotificationCount.data,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RIcon/* default */.Z, {
                        name: "notifications"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                id: "simple-popover",
                open: Boolean(anchorEl),
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right"
                },
                slotProps: {
                    paper: {
                        sx: {
                            width: isMobile ? "76vw" : "50vw",
                            pr: 0.2,
                            border: "3px solid gray",
                            outline: "3px solid white",
                            background: "#f3f7f5"
                        }
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        width: "100%"
                    },
                    children: [
                        lstNotification.data && lstNotification.data.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    cursor: "pointer",
                                    width: "100%",
                                    paddingLeft: 8,
                                    paddingBottom: 4,
                                    paddingTop: 4,
                                    borderBottom: "1px solid grey",
                                    background: item.IsRead ? undefined : (0,colorManipulator/* lighten */.$n)(colors/* default.Green.light */.Z.Green.light, 0.6)
                                },
                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!!item.IsRead) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    markNotificationRead.mutateAsync({
                                                        NotificationInstanceIDs: [
                                                            item._id
                                                        ]
                                                    })
                                                ];
                                            case 1:
                                                _state.sent();
                                                ReactQueryClient/* queryClient.refetchQueries */.Eh.refetchQueries([
                                                    "notification-instance"
                                                ]);
                                                unreadNotificationCount.refetch();
                                                _state.label = 2;
                                            case 2:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: item.Title
                                            }
                                        }),
                                        placement: "left",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex-v-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        width: "100%",
                                                        overflowY: "hidden",
                                                        height: 18,
                                                        justifyContent: "space-between"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: item.Title
                                                        }
                                                    })
                                                }),
                                                !item.IsRead && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    style: {
                                                        color: "green",
                                                        marginLeft: "8px"
                                                    },
                                                    fontSize: 15,
                                                    fontWeight: 600,
                                                    component: "span",
                                                    children: "New"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        display: "flex",
                                                        justifyContent: "right",
                                                        pr: 2,
                                                        whiteSpace: "nowrap"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        color: "primary",
                                                        paddingLeft: 2,
                                                        children: Utils/* default.convertToSystemDateTimeFormate */.Z.convertToSystemDateTimeFormate(item.CreatedAt)
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    item.Description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: item.Description
                                            }
                                        }),
                                        placement: "left",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex-v-center",
                                            style: {
                                                width: "100%",
                                                overflowY: "hidden",
                                                height: 17
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: item.Description
                                                }
                                            })
                                        })
                                    })
                                ]
                            }, item._id);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                justifyContent: "right",
                                position: "sticky",
                                bottom: 0,
                                bgcolor: "white",
                                borderTop: "2px solid ".concat(colors/* default.Blue.light */.Z.Blue.light)
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "text",
                                sx: {
                                    pr: 1
                                },
                                onClick: function() {
                                    setAnchorEl(null);
                                    router.push("/notification-instance");
                                },
                                children: "View All"
                            })
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js
var Menu = __webpack_require__(24486);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(63931);
// EXTERNAL MODULE: ../commonlib/dist/index.js
var dist = __webpack_require__(19129);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/addSeconds/index.js
var addSeconds = __webpack_require__(30927);
;// CONCATENATED MODULE: ./common/custom/SystemUserAvatar.tsx








function LoggedInUserAvatar(props) {
    var user = (0,AuthContext/* useAuth */.a)().user;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(user === null || user === void 0 ? void 0 : user.ServerDateTime), 2), serverDateTime = ref[0], setServerDateTime = ref[1];
    react.useEffect(function() {
        var timer = setInterval(function() {
            setServerDateTime(function(date) {
                if (!date) return null;
                return dist.CommonDateUtils.format((0,addSeconds/* default */.Z)(new Date(date), 1), "yyyy-MM-dd hh:mm:ss a");
            });
        }, 1000);
        return function() {
            clearInterval(timer);
        };
    }, []);
    var localDateTime = dist.CommonDateUtils.format(new Date(), "yyyy-MM-dd hh:mm:ss a");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex",
            alignItems: "center"
        },
        children: [
            props.withName && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            user === null || user === void 0 ? void 0 : user.FirstName,
                            " ",
                            user === null || user === void 0 ? void 0 : user.LastName
                        ]
                    }),
                    AuthServices/* default.is */.Z.is("SYSTEM_ADMIN") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        title: "Server",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                fontSize: 10
                            },
                            children: serverDateTime
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        title: "Local",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                fontSize: 10
                            },
                            children: localDateTime
                        })
                    })
                ]
            }),
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                size: "large",
                edge: "end",
                onClick: props.handleClick,
                color: "inherit",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    children: user ? getUserInitial(user) : undefined
                })
            })
        ]
    });
}
function getUserInitial(user) {
    var ref, ref1;
    return "".concat(((ref = user.FirstName) === null || ref === void 0 ? void 0 : ref.substring(0, 1)) || "").concat(((ref1 = user.LastName) === null || ref1 === void 0 ? void 0 : ref1.substring(0, 1)) || "");
}

;// CONCATENATED MODULE: ./layouts/main/ProfileMenu.tsx
















function ProfileMenu() {
    var ref, ref1;
    var auth = (0,AuthContext/* useAuth */.a)();
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref2[0], setAnchorEl = ref2[1];
    var open = Boolean(anchorEl);
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var isMobile = (0,userIsMobile/* default */.Z)();
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {},
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoggedInUserAvatar, {
                withName: !isMobile,
                handleClick: handleClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* default */.Z, {
                id: "fade-menu",
                MenuListProps: {
                    "aria-labelledby": "fade-button"
                },
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                TransitionComponent: Fade/* default */.Z,
                children: [
                    ((ref = auth.user) === null || ref === void 0 ? void 0 : ref.ClientPublicIP) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            margin: "0px 10px",
                            // fontSize: "12px",
                            borderBottom: "1px solid grey"
                        },
                        children: [
                            "IP: ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: (ref1 = auth.user) === null || ref1 === void 0 ? void 0 : ref1.ClientPublicIP
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                title: "Copy IP address",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    onClick: function() {
                                        var ref;
                                        Utils/* default.copyToClipboard */.Z.copyToClipboard((ref = auth.user) === null || ref === void 0 ? void 0 : ref.ClientPublicIP);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RIcon/* default */.Z, {
                                        name: "content_copy"
                                    })
                                })
                            })
                        ]
                    }),
                    AuthServices/* default.is */.Z.is("SYSTEM_ADMIN") && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        onClick: function() {
                            router.push("/profile");
                            handleClose();
                        },
                        children: "Profile"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        onClick: function() {
                            router.push("/my-account");
                            handleClose();
                        },
                        children: "My account"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                AuthServices/* default.onLogout */.Z.onLogout();
                                handleClose();
                                return [
                                    2
                                ];
                            });
                        }),
                        children: "Logout"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./layouts/main/MainAppBar.tsx


















var useStyles = (0,makeStyles/* default */.Z)({
    scrollPaper: {
        alignItems: "flex-start",
        paddingTop: "70px"
    }
});
var Transition = /*#__PURE__*/ react.forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, (0,_object_spread/* default */.Z)({
        direction: "up",
        ref: ref
    }, props));
});
function MainAppBar(props) {
    var filterBookMarks = function filterBookMarks(user, bookmarkLst) {
        var rolesBookmark = bookmarkLst === null || bookmarkLst === void 0 ? void 0 : bookmarkLst.filter(function(item) {
            var isMatch = false;
            if (user === null || user === void 0 ? void 0 : user.IsAdminUser) {
                isMatch = item.ShownOnRoles === (user === null || user === void 0 ? void 0 : user.Role);
            } else {
                var ref, ref1;
                var userAccessRoles = user === null || user === void 0 ? void 0 : (ref = user.Access) === null || ref === void 0 ? void 0 : (ref1 = ref.MasterClients) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                    return item.Role;
                });
                isMatch = userAccessRoles === null || userAccessRoles === void 0 ? void 0 : userAccessRoles.includes(item.ShownOnRoles);
            }
            return isMatch || item.ShownOnRoles === "PUBLIC";
        });
        return rolesBookmark === null || rolesBookmark === void 0 ? void 0 : rolesBookmark.sort(function(a, b) {
            return a.OrderIndex - b.OrderIndex;
        });
    };
    var user = (0,AuthContext/* useAuth */.a)().user;
    var isMobile = (0,userIsMobile/* default */.Z)();
    var classes = useStyles();
    var theme = (0,useTheme/* default */.Z)();
    var list = (0,commonQuries/* useList */.sm)("bookmark", {
        filter: {
            IsActive: true
        },
        query: {
            pageSize: 0,
            page: 0
        }
    });
    var searchModal = (0,useModal/* default */.Z)(function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalSearchModal, (0,_object_spread/* default */.Z)({}, props));
    }, {
        maxWidth: "sm",
        noTitle: true,
        dialogProps: {
            onClose: function() {
                searchModal.toggle(false);
            },
            classes: {
                scrollPaper: classes.scrollPaper
            },
            TransitionComponent: Transition
        },
        onComplete: function() {
            searchModal.toggle(false);
        }
    });
    (0,react.useEffect)(function() {
        var handleClick = function(event) {
            if ((event.keyCode === 91 || event.keyCode === 75) && event.ctrlKey) {
                event.preventDefault();
                event.stopPropagation();
                searchModal.toggle(true);
            }
        };
        document.addEventListener("keydown", handleClick);
        // remove the event listener when component umount
        return function() {
            document.removeEventListener("keydown", handleClick);
        };
    }, []);
    var bookmarkLst = filterBookMarks(user, list === null || list === void 0 ? void 0 : list.data);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
        id: "divToolbar",
        sx: {
            display: "flex",
            alignContent: "center",
            background: "white",
            boxShadow: function(theme) {
                return theme.shadows[3];
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                },
                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    onClick: function() {
                        (0,commonStore/* setIsDrawerOpenOnMobile */.L8)();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RIcon/* default */.Z, {
                        name: "menu"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    overflowX: "scroll",
                    maxWidth: "60%"
                },
                children: !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "flex-start"
                    },
                    children: bookmarkLst && bookmarkLst.map(function(item, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)((link_default()), {
                            href: item.Link,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                target: "_blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                    title: item.Title,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        style: {
                                            cursor: "pointer",
                                            marginLeft: "15px",
                                            color: Utils/* default.getContrastText */.Z.getContrastText(theme, item === null || item === void 0 ? void 0 : item.BackgroundColor),
                                            backgroundColor: item.BackgroundColor
                                        },
                                        src: item.Icon,
                                        children: item.Icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RIcon/* default */.Z, {
                                            name: item.Icon,
                                            sx: {
                                                color: Utils/* default.getContrastText */.Z.getContrastText(theme, item === null || item === void 0 ? void 0 : item.BackgroundColor)
                                            }
                                        }) : Utils/* default.getFirstCharCap */.Z.getFirstCharCap(item.Title)
                                    }, item._id)
                                })
                            })
                        }, index);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    flexGrow: 1
                }
            }),
            !props.NoMasterClientSelector && /*#__PURE__*/ (0,jsx_runtime.jsx)(MasterClientSelector, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationMenu, {}),
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenu, {}),
            searchModal.render()
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/material/Icon/Icon.js
var Icon = __webpack_require__(51190);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js
var Drawer = __webpack_require__(19058);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js
var Collapse = __webpack_require__(12509);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js
var List = __webpack_require__(18843);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(98619);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(48885);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/Handyman.js
var Handyman = __webpack_require__(64271);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/Home.js
var Home = __webpack_require__(33229);
;// CONCATENATED MODULE: ./layouts/main/SidebarConfig.tsx



var sidebarConfig = [
    {
        title: "Home",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home/* default */.Z, {}),
        path: "/"
    },
    {
        title: "Master Client",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Handyman/* default */.Z, {}),
        path: "/master-client"
    },
    {
        title: "System Users",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Handyman/* default */.Z, {}),
        path: "/system-users"
    }, 
];
function isItemSelected(item, urlPath) {
    var isSelected = item.Path && urlPath === item.Path;
    return isSelected;
}
function isChildrenSelected(item, urlPath) {
    var ref;
    return (ref = item.Children) === null || ref === void 0 ? void 0 : ref.some(function(i) {
        return isItemSelected(i, urlPath);
    });
}
/* harmony default export */ var SidebarConfig = ((/* unused pure expression or super */ null && (sidebarConfig)));

;// CONCATENATED MODULE: ./layouts/main/SideNavList.tsx













function SideNavList() {
    var navControls = (0,commonQuries/* useList */.sm)("nav-list").data;
    if (!navControls) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuList, {
        lstMenu: navControls,
        depth: 0
    });
}
function MenuList(param) {
    var lstMenu = param.lstMenu, depth = param.depth;
    var router = (0,next_router.useRouter)();
    var ref = commonStore/* CommonStore.useState */.w4.useState(function(store) {
        return store;
    }), menuCollapseStatus = ref.menuCollapseStatus, isDrawerMini = ref.isDrawerMini;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
            children: lstMenu && lstMenu.map(function(item, index) {
                var isSelected = isItemSelected(item, router.asPath) || isChildrenSelected(item, router.asPath);
                var isChildSelected = isChildrenSelected(item, router.asPath);
                var isExpanded = isChildSelected || menuCollapseStatus[index.toString()];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: item.Path || "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                        disablePadding: true,
                        sx: {
                            display: "block",
                            pl: depth * (isDrawerMini ? 1 : 3)
                        },
                        divider: index < lstMenu.length - 1,
                        component: item.Children ? "li" : "a",
                        href: item.Path,
                        onClick: function() {
                            if (!item.Children) (0,commonStore/* setDrawerWidth */.Cv)("mini");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton/* default */.Z, {
                                disableRipple: true,
                                sx: {},
                                onClick: function(e) {
                                    (0,commonStore/* setIsDrawerOpenOnMobile */.L8)(false);
                                    if (item.Path) {
                                        if (item.target === "new") window.open(item.Path);
                                        else router.push(item.Path);
                                    } else {
                                        e.preventDefault();
                                        (0,commonStore/* setMenuCollapse */.$2)(index.toString(), !isExpanded);
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                        sx: {
                                            minWidth: 30
                                        },
                                        children: item.Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            color: isSelected ? "primary" : "inherit",
                                            children: item.Icon
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                        primary: item.Title,
                                        sx: {
                                            whiteSpace: "nowrap",
                                            visibility: isDrawerMini ? "hidden" : "visible",
                                            color: isSelected ? "var(--primary)" : ""
                                        }
                                    }),
                                    !isDrawerMini && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: item.Children && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                            sx: {
                                                minWidth: 0,
                                                mr: isExpanded ? 0 : "auto",
                                                justifyContent: "center"
                                            },
                                            children: isExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RIcon/* default */.Z, {
                                                name: "arrow_drop_down"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RIcon/* default */.Z, {
                                                name: "arrow_right"
                                            })
                                        })
                                    })
                                ]
                            }),
                            item.Children && /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                                in: isExpanded,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuList, {
                                    lstMenu: item.Children,
                                    depth: depth + 1
                                })
                            })
                        ]
                    })
                }, index);
            })
        })
    });
}

;// CONCATENATED MODULE: ./layouts/main/MainDrawer.tsx








var drawerTimeout = null;
function MainDrawer() {
    var ref = commonStore/* CommonStore.useState */.w4.useState(function(store) {
        return store;
    }), drawerWidth = ref.drawerWidth, isFixedMenu = ref.isFixedMenu, isDrawerOpenOnMobile = ref.isDrawerOpenOnMobile;
    var isMobile = (0,userIsMobile/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
        open: isMobile ? isDrawerOpenOnMobile : true,
        variant: isMobile ? "temporary" : "permanent",
        elevation: 10,
        onClose: function() {
            if (!isMobile) return;
            (0,commonStore/* setIsDrawerOpenOnMobile */.L8)(false);
        },
        PaperProps: {
            sx: {
                transition: "all 0.2s",
                boxShadow: "rgb(0 0 0 / 6%) 0px 5px 5px -3px, rgb(0 0 0 / 4%) 0px 8px 10px 1px, rgb(0 0 0 / 4%) 0px 3px 14px 2px"
            }
        },
        sx: (0,_define_property/* default */.Z)({
            width: drawerWidth,
            flexShrink: 0
        }, "& .MuiDrawer-paper", {
            width: drawerWidth,
            boxSizing: "border-box"
        }),
        onMouseEnter: function() {
            if (isMobile) return;
            drawerTimeout = setTimeout(function() {
                (0,commonStore/* setDrawerWidth */.Cv)("full");
            }, 200);
        },
        onMouseLeave: function() {
            if (isMobile) return;
            clearTimeout(drawerTimeout);
            (0,commonStore/* setDrawerWidth */.Cv)("mini");
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    padding: "5px 8px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/logo.png",
                        style: {
                            maxHeight: 40
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            flexGrow: 1,
                            minWidth: 50
                        }
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        color: "inherit",
                        "aria-label": "open drawer",
                        onClick: function() {
                            (0,commonStore/* setMenuFixed */.rU)();
                        },
                        edge: "start",
                        sx: {},
                        children: !isFixedMenu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            children: "arrow_circle_right"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            children: "arrow_circle_left"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    overflowY: "auto",
                    overflowX: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideNavList, {})
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/pullstate/dist/index.es.js + 1 modules
var index_es = __webpack_require__(81928);
;// CONCATENATED MODULE: ./stores/taskPanelStore.ts


var TaskPanelStore = new index_es/* Store */.yh({
    objModals: {}
});
function minimizePanel(obj) {
    var id = obj.panelID || createUUID();
    TaskPanelStore.update(function(s) {
        s.objModals[id] = {
            id: id,
            title: obj.title || "No title",
            setOpen: obj.setOpen
        };
    });
    obj.setOpen(false);
    return obj;
}
function maximizePanel(panelID) {
    var objPanel = TaskPanelStore.getRawState().objModals[panelID];
    objPanel.setOpen(true);
    TaskPanelStore.update(function(s) {
        delete s.objModals[panelID];
    });
}
function removePanel(panelID) {
    TaskPanelStore.update(function(s) {
        delete s.objModals[panelID];
    });
} // TaskPanelStore.listenToPatches((patches) => {
 //   let patch = patches.find((item) =>
 //     item.path.includes("selectedMasterClient")
 //   );
 //   if (patch) {
 //     LocalStorageUtils.lsSet("selectedMasterClient", patch.value);
 //   }
 // });

// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/ArrowDropUp.js
var ArrowDropUp = __webpack_require__(92795);
;// CONCATENATED MODULE: ./layouts/main/TaskPanel.tsx




function TaskPanel() {
    var objModals = TaskPanelStore.useState().objModals;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            position: "fixed",
            right: 0,
            bottom: 0,
            width: "100%",
            boxShadow: "-1px -1px 10px 2px grey",
            background: "white",
            padding: 5,
            display: Object.keys(objModals).length > 0 ? "flex" : "none",
            flexDirection: "row-reverse"
        },
        children: Object.keys(objModals).map(function(key) {
            var obj = objModals[key];
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    width: 130,
                    height: 35,
                    background: "#e1e1e1",
                    padding: "5px",
                    borderRadius: 10,
                    cursor: "pointer",
                    userSelect: "none",
                    display: "flex",
                    alignItems: "center"
                },
                onClick: function() {
                    maximizePanel(obj.id);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDropUp/* default */.Z, {
                        color: "primary",
                        fontSize: "large",
                        style: {
                            padding: 0
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            width: "65%",
                            textOverflow: "clip",
                            overflow: "hidden",
                            whiteSpace: "nowrap"
                        },
                        children: obj.title
                    })
                ]
            }, key);
        })
    });
}

;// CONCATENATED MODULE: ./layouts/main/MainLayout.tsx














function MainLayout(props) {
    var ref = commonStore/* CommonStore.useState */.w4.useState(function(s) {
        return s;
    }), drawerWidth = ref.drawerWidth, isFixedMenu = ref.isFixedMenu;
    var isMobile = (0,userIsMobile/* default */.Z)();
    var menuPadding = drawerWidth;
    if (!isFixedMenu) {
        menuPadding = commonStore/* drawerWidths.mini */.Ad.mini;
    }
    if (isMobile) menuPadding = 0;
    (0,react.useEffect)(function() {
        (0,NavigationListener/* CreateUserAccessHistory */.r)().catch(function(ex) {
            console.log("Error occurred while adding navigation history. ".concat((0,dist_module.parseErrorString)(ex)));
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        window.location.href
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            display: "flex",
            flexDirection: "column",
            height: "100vh"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainDrawer, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppTitle, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                component: "main",
                sx: {
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    transition: "all 0.3s",
                    height: "100vh",
                    overflow: "hidden"
                },
                style: {
                    paddingLeft: menuPadding
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainAppBar, {
                            NoMasterClientSelector: props.NoMasterClientSelector
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        id: "divContentArea",
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.noScroll ? {} : {
                            overflow: "auto"
                        }), {
                            height: "100%"
                        }),
                        children: props.children
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TaskPanel, {})
        ]
    });
}


/***/ }),

/***/ 88658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ setMenuCollapse; },
/* harmony export */   "Ad": function() { return /* binding */ drawerWidths; },
/* harmony export */   "Cv": function() { return /* binding */ setDrawerWidth; },
/* harmony export */   "If": function() { return /* binding */ getContentHeight; },
/* harmony export */   "L8": function() { return /* binding */ setIsDrawerOpenOnMobile; },
/* harmony export */   "rU": function() { return /* binding */ setMenuFixed; },
/* harmony export */   "w4": function() { return /* binding */ CommonStore; }
/* harmony export */ });
/* unused harmony export setForceRender */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96670);
/* harmony import */ var pullstate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81928);
/* harmony import */ var utils_winUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94212);





var drawerWidths = {
    mini: 60,
    full: 260
};
var CommonStore = new pullstate__WEBPACK_IMPORTED_MODULE_0__/* .Store */ .yh({
    drawerWidth: drawerWidths.mini,
    selectedBottomTab: "",
    menuCollapseStatus: {},
    isDrawerMini: true,
    isFixedMenu: false,
    isDrawerOpenOnMobile: false,
    forceRender: false
});
function setMenuCollapse(key, isExpanded) {
    CommonStore.update(function(s) {
        s.menuCollapseStatus = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, s.menuCollapseStatus), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, key, isExpanded));
    });
}
function setDrawerWidth(size) {
    CommonStore.update(function(s) {
        if (s.isFixedMenu) return; // No change in drawer width in fixed
        if (size !== undefined) {
            s.drawerWidth = drawerWidths[size];
        } else {
            s.drawerWidth = s.drawerWidth === drawerWidths.mini ? drawerWidths.full : drawerWidths.mini;
        }
        s.isDrawerMini = s.drawerWidth === drawerWidths.mini;
    });
}
function setMenuFixed(isFixedMenu) {
    CommonStore.update(function(s) {
        var newVal = isFixedMenu !== undefined ? isFixedMenu : !s.isFixedMenu;
        s.isFixedMenu = newVal;
        if (newVal) {
            s.isDrawerMini = false;
            s.drawerWidth = drawerWidths.full;
        } else {
        // s.isDrawerMini = true;
        // s.drawerWidth = drawerWidths.mini;
        }
    });
}
function getContentHeight() {
    var win = (0,utils_winUtils__WEBPACK_IMPORTED_MODULE_4__/* .getWindow */ .Jj)();
    if (!win) return "100vh";
    var wHeight = win.innerHeight;
    var divToolbar = document.getElementById("divToolbar");
    if (divToolbar) {
        wHeight -= divToolbar.clientHeight;
    }
    return wHeight;
}
function setIsDrawerOpenOnMobile(open) {
    CommonStore.update(function(s) {
        var newVal = open !== undefined ? open : !s.isDrawerOpenOnMobile;
        s.isDrawerOpenOnMobile = newVal;
    });
    setDrawerWidth("full");
}
function setForceRender(forceRender) {
    CommonStore.update(function(s) {
        s.forceRender = forceRender;
    });
    setDrawerWidth("full");
}


/***/ }),

/***/ 31587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73594);
/* harmony import */ var _winUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94212);





var SnackBarUtils = /*#__PURE__*/ function() {
    "use strict";
    function SnackBarUtils() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, SnackBarUtils);
    }
    SnackBarUtils.Show = function Show(message, options) {
        var id = (0,notistack__WEBPACK_IMPORTED_MODULE_1__/* .enqueueSnackbar */ .yv)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            message: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: message
            })
        }, options));
    };
    return SnackBarUtils;
}();
(0,_winUtils__WEBPACK_IMPORTED_MODULE_4__/* .setWindow */ .O6)("SnackBarUtils", SnackBarUtils);
/* harmony default export */ __webpack_exports__["Z"] = (SnackBarUtils);


/***/ })

}]);